import React, { useState } from 'react'

import { Button, Checkbox } from '@driftt/dds'

import EmailTemplateModal from 'components/MeetingEditComponents/EmailTemplatesModal'
import {
  GuestNotification,
  GuestNotifications,
  GuestNotificationTypeEnum,
} from 'types/MeetingType'

import { FollowUpEmailTable } from './FollowUpEmailTable'

interface GuestEmailSettingsProps {
  guestNotifications: GuestNotifications
  updateState: (
    guestNotifications: Record<GuestNotificationTypeEnum, GuestNotification>
  ) => void
  disabled: boolean
  isOrgMeeting: boolean
}

export const GuestEmailSettings = ({
  guestNotifications,
  updateState,
  disabled,
  isOrgMeeting,
}: GuestEmailSettingsProps) => {
  const [modalEditMode, setModalEditMode] =
    useState<GuestNotificationTypeEnum>()
  const toggleEmailTemplate = (type: GuestNotificationTypeEnum) => {
    guestNotifications[type].on = !guestNotifications[type].on
    updateState(guestNotifications)
  }
  const onChangeNotificationSettings = (
    notificationTypes: GuestNotificationTypeEnum[],
    val: boolean
  ) => {
    notificationTypes.forEach((type) => (guestNotifications[type].on = val))
    updateState(guestNotifications)
  }
  const onSaveTemplate = (updatedGuestNotifications: any) => {
    updateState(updatedGuestNotifications)
    closeModal()
  }
  const emailRemindersEnabled =
    guestNotifications[GuestNotificationTypeEnum.MEETING_REMINDER].on ||
    guestNotifications[GuestNotificationTypeEnum.MEETING_REMINDER_FOLLOW].on

  const closeModal = () => setModalEditMode(undefined)
  return (
    <>
      <Checkbox
        label="Send a personalized email confirmation 15 minutes after this meeting is booked"
        checked={
          guestNotifications[GuestNotificationTypeEnum.MEETING_CONFIRMATION].on
        }
        onChange={(val) => {
          onChangeNotificationSettings(
            [GuestNotificationTypeEnum.MEETING_CONFIRMATION],
            val
          )
        }}
        disabled={disabled}
      />
      <Button
        variant={'secondary'}
        onClick={() => {
          setModalEditMode(GuestNotificationTypeEnum.MEETING_CONFIRMATION)
        }}
      >
        Edit email template
      </Button>
      <Checkbox
        label="Send personalized email reminder(s) before your meeting"
        checked={emailRemindersEnabled}
        onChange={(val) => {
          onChangeNotificationSettings(
            [
              GuestNotificationTypeEnum.MEETING_REMINDER,
              GuestNotificationTypeEnum.MEETING_REMINDER_FOLLOW,
            ],
            val
          )
        }}
        disabled={disabled}
      />
      <FollowUpEmailTable
        guestNotifications={guestNotifications}
        toggleEmailTemplate={toggleEmailTemplate}
        disabled={disabled}
        setModalEditMode={setModalEditMode}
      />
      {modalEditMode && (
        <EmailTemplateModal
          readOnly={disabled}
          onClose={closeModal}
          onSave={onSaveTemplate}
          isOrgMeeting={isOrgMeeting}
          guestNotifications={guestNotifications}
          type={modalEditMode}
        />
      )}
    </>
  )
}
